export const unwrapColumnsFromGroups = (items) => {
    return items.reduce((acc, currentItem) => {
        return [...acc, ...currentItem.columns];
    }, []);
};
